export default __webpack_public_path__ + "static/media/pointer.aedd1b5f.svg";